import React, { useState, useEffect } from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import './WhatsAppButton.css';

const WhatsAppButton = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [showTooltip, setShowTooltip] = useState(false);

  // Numéro de téléphone au format international (sans le +)
  const phoneNumber = "2290158585050"; 
  
  // Message pré-défini (optionnel)
  const defaultMessage = "Bonjour, je souhaite obtenir plus d'informations sur vos services.";
  
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(defaultMessage)}`;

//   // Cacher le bouton quand on scroll vers le bas, réapparaître quand on remonte
//   useEffect(() => {
//     const handleScroll = () => {
//       const currentScrollY = window.scrollY;
//       if (currentScrollY > lastScrollY && currentScrollY > 100) {
//         setIsVisible(false);
//       } else {
//         setIsVisible(true);
//       }
//       setLastScrollY(currentScrollY);
//     };

//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, [lastScrollY]);

  const handleClick = () => {
    window.open(whatsappUrl, '_blank');
  };

  return (
    <div 
      className="whatsapp-float"
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <button className="whatsapp-button" onClick={handleClick}>
        <FaWhatsapp className="whatsapp-icon" />
      </button>
      {showTooltip && (
        <div className="whatsapp-tooltip">
          <span>Discutons sur WhatsApp !</span>
        </div>
      )}
    </div>
  );
};

export default WhatsAppButton;